/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateFileMetadataSchema = z.object({
	sourceEmailId: z.string().nullable(),
	sourceEmailSubject: z.string().nullable(),
})

export type CandidateFileMetadataSchema = z.infer<typeof candidateFileMetadataSchema>
